import React, { useState } from 'react';
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Pagination,
  Stack,
  Drawer,
  Typography,
  useMediaQuery,
} from '@mui/material';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ManIcon from '@mui/icons-material/Man';
import {
  BackdropLoading,
  BookButton,
  BookSearchDropDownField,
  BookSearchField,
  CardComponent,
} from '../../components';


import { WHITE_COLOR, GREY_COLOR } from '../../styles/constants';
import { TableHeadComponent, TableRows } from '../../components';
import ContentModal from '../modals/chaptercontent';
import { useTheme } from '@mui/material/styles';
import { useContent } from './hooks/ChapterContent.hook';
import { useStyles } from './ChapterContent.style';
import AddIcon from '@mui/icons-material/Add';
import parse from 'html-react-parser';
import UrduContentDrawer from './UrduContentDrawer';

const ChapterContentTable = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    ContentData,
    action,
    ContentCount,
    open,
    setOpen,
    singleContent,
    tableCells,
    actionsIcons,
    limit,
    page,
    isLoading,
    chapterData,
    bookData,
    searchKey,
    selectedBookId,
    filters,
    drawerOpen,
    drawerContent,
    handleGetContentData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleContentSearch,
    handleDropDown,
    handleBookGetChapter,
    handleFilterChange,
    handleContentClick,
    handleCloseDrawer,
  } = useContent();

  const dataIcons = [
    { id: 'chapterId', title: 'Chapter Name', gridTitleSize: 5, gridSize: 6 },
    {
      id: 'pageNo',
      title: 'Page No',
      gridTitleSize: 5,
      gridSize: 6,
      icon: (
        <ManIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
    {
      id: 'content',
      title: 'Content',
      gridTitleSize: 5,
      gridSize: 7,
      icon: (
        <ContactPhoneIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
    {
      id: 'url',
      title: 'Url',
      gridTitleSize: 5,
      gridSize: 7,
      icon: (
        <ContactPhoneIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
  ];

  const getDirection = (text) => {
    const firstChar = text.trim().charAt(0);
    return /[\u0600-\u06FF]/.test(firstChar) ? 'rtl' : 'ltr'; // Urdu/Arabic Unicode range
  };

  const cleanToPlainText = (html) => {
    return html
      .replace(/<[^>]+>/g, '')        // Remove HTML tags
      .replace(/&nbsp;/gi, ' ')       // Replace &nbsp; with space
      .replace(/\s+/g, ' ')           // Collapse multiple spaces/newlines
      .trim();                        // Trim ends
  };

  return (
    <Box component='div' sx={isMobile && { paddingBottom: 10 }}>
      {open && (
        <ContentModal
          tableCells={tableCells}
          open={open}
          setOpen={setOpen}
          singleContent={singleContent}
          action={action}
          handleGetContentData={handleGetContentData}
          chapterData={chapterData}
          bookData={bookData}
          handleBookGetChapter={handleBookGetChapter}
          selectedBookId={selectedBookId}
        />
      )}
      <BackdropLoading open={isLoading} />
      <Box
        component='div'
        sx={{
          width: '100%',
          position: isMobile && 'sticky',
          top: isMobile && '7rem',
          zIndex: isMobile && 1000,
          background: 'white',
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={2} lg={2}>
            {/* <BookSearchDropDownField
              type='select'
              searchKey={searchKey}
              handleDropDown={handleDropDown}
              sx={{ width: isMobile ? '100%' : '100%' }}
              selectOptions={[
                { value: 'pageNo', text: 'Page No' },
              ]}
            /> */}
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            {/* <BookSearchField
              type='text'
              handleSearch={handleContentSearch}
              sx={{ width: isMobile ? '100%' : '50%' }}
            /> */}
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <BookButton
              onSubmit={handleAdd}
              title='Add Content'
              type='primary'
              variant='contained'
              icon={<AddIcon />}
            />
          </Grid>
        </Grid>
      </Box>
      {isMobile ? (
        <>
          {ContentData &&
            Object.keys(ContentData).length > 0 &&
            ContentData?.map(row => (
              <CardComponent
                key={'ContentDara' + row.id}
                sx={{
                  background: GREY_COLOR.GHOSTWHITE,
                  width: '97%',
                  margin: '20px 5px 5px 5px',
                }}
                classBorder={
                  Object.keys(row['measurement']).length > 0
                    ? classes.statusCompleted
                    : classes.statusPending
                }
                titleStyle={classes.titleStyle}
                uniqueKey='-ContentCrud'
                rows={row}
                dataIcons={dataIcons}
                tableCells={tableCells}
                actionsIcons={actionsIcons}
                handleActionClick={handleActionClick}
              />
            ))}
          <Stack className={classes.paginationStyle} spacing={2}>
            <Pagination
              count={calculatePagesCount(limit, ContentCount)}
              page={page + 1}
              onChange={(event, newPage) => handleChangePage(true, newPage)}
              color='primary'
            />
          </Stack>
        </>
      ) : (
        <>
          <TableContainer
            sx={{
              width: '100%',
              background: WHITE_COLOR,
            }}
          >
            <Table sx={{ minWidth: '100%' }} aria-label='simple table'>
              <TableHeadComponent tableCells={tableCells} showFilter={true} onFilterChange={handleFilterChange} filters={filters} />
              <TableBody>
                <TableRows
                  uniqueKey='-ContentCrud'
                  tableCells={tableCells}
                  rows={ContentData}
                  actionsIcons={actionsIcons}
                  handleActionClick={handleActionClick}
                  handleContentClick={handleContentClick}
                />
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component='div'
            count={ContentCount}
            page={page}
            onPageChange={(event, newPage) => handleChangePage(false, newPage)}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[25, 50, 100, 250, 500, 750, 1000]}
          />
        </>
      )}
      {drawerOpen && (
        <UrduContentDrawer 
          drawerOpen={drawerOpen}
          handleCloseDrawer={handleCloseDrawer}
          drawerContent={drawerContent?.content}
          language={drawerContent?.language}
        />
      )}
      {/* <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleCloseDrawer}
      >
        <Box sx={{ width: 600, p: 3 }}>
          <Typography variant="h6" gutterBottom>Full Content</Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "'Jameel Noori Nastaleeq', serif",
              whiteSpace: 'pre-wrap',
              direction: getDirection(cleanToPlainText(drawerContent)),
              textAlign: getDirection(cleanToPlainText(drawerContent)) === 'rtl' ? 'right' : 'left',
              fontSize: '18px',
              lineHeight: 1.8,
            }}
          >
            {drawerContent ? parse(drawerContent) : drawerContent}
          </Typography>
        </Box>
      </Drawer> */}
    </Box>
  );
};
export default ChapterContentTable;
